import React, { Component } from "react";
import PropTypes from "prop-types";

import { TEAM_UPDATE_PAGE_LINK } from "config";
import deviceServices from "services/deviceServices";
import PostIframe from "../../../shared/PostIframe/PostIframe";

import localize from "lang/localize";

const propTypes = {
  sessionKey: PropTypes.string.isRequired,
  teamId: PropTypes.string.isRequired,
  language: PropTypes.string
};

class TeamUpdatePage extends Component {
  render() {
    return (
      <div
        className={
          "fullscreen-frame-wrap" +
          (deviceServices.isIOS() ? " iframe-scroll-wrapper" : "")
        }
      >
        <PostIframe
          title={localize("update_team_text", this.props.language)}
          hiddenFields={{
            session_key: this.props.sessionKey,
            team_id: this.props.teamId
          }}
          url={TEAM_UPDATE_PAGE_LINK}
        />
      </div>
    );
  }
}

TeamUpdatePage.propTypes = propTypes;

export default TeamUpdatePage;
